import type { SQLiteUpdateSetSource } from 'drizzle-orm/sqlite-core'
import { portfolioTable } from '../schema'
import type { DatabaseWithTransaction } from '../types'

type UpdatePortfolioParameters = {
  database: DatabaseWithTransaction
  updating: Partial<
    Omit<SQLiteUpdateSetSource<typeof portfolioTable>, 'timezone'>
  >
}

export const updatePortfolio = async ({
  database: { database },
  updating,
}: UpdatePortfolioParameters) => {
  await database.update(portfolioTable).set(updating)
}
